/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest, FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestFromJSONTyped, FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestToJSON, } from './FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest';
export function FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductFromJSON(json) {
    return FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductFromJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest(json)) {
        return FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductToJSON(json) {
    return FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductToJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProductToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequest(value)) {
        return FxIdApplicationStoreInAppRuStoreRuStoreValidateProductRequestToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreInAppInAppValidationRequestRuStoreValidateProduct.js.map